import React from 'react';
import { Chip, Typography } from '@mui/material';
import { DEMO_PORTFOLIO_URL } from 'config/demo';
import Div from 'components/global/div';

const DemoBanner: React.FunctionComponent = () => {
  return (
    <Div
      sx={{
        position: 'sticky',
        top: 0,
        zIndex: 1100,
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1.5,
        px: 2,
        py: 1,
        background: theme => theme.palette.primary.main,
        color: theme => theme.palette.primary.contrastText,
      }}
    >
      <Chip
        label="Demo"
        size="small"
        sx={{
          fontWeight: 'bold',
          backgroundColor: 'rgba(255, 255, 255, 0.2)',
          color: 'inherit',
        }}
      />
      <Typography variant="body2" sx={{ fontWeight: 500 }}>
        Portfolio demo — read-only. Transactions disabled.
      </Typography>
      {DEMO_PORTFOLIO_URL ? (
        <Typography
          component="a"
          href={DEMO_PORTFOLIO_URL}
          target="_blank"
          rel="noopener noreferrer"
          variant="body2"
          sx={{ color: 'inherit', textDecoration: 'underline', ml: 1 }}
        >
          Back to portfolio
        </Typography>
      ) : null}
    </Div>
  );
};

export default DemoBanner;
